import { render, staticRenderFns } from "./sum-card.vue?vue&type=template&id=7475985c&scoped=true"
import script from "./sum-card.vue?vue&type=script&lang=js"
export * from "./sum-card.vue?vue&type=script&lang=js"
import style0 from "./sum-card.vue?vue&type=style&index=0&id=7475985c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7475985c",
  null
  
)

export default component.exports